<template>
  <div class="tipo">
    <div class="centro">
      <h1>Consulta por Tipo de Ato Infralegal</h1>
      <BuscaSimplesCards
        titulo="Consultas Rápidas"
        :cards="cardsAtoInfralegal"
      />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelBuscaSimplificada
        :dados="tiposFormatados"
        :generateUrl="generateUrl"
        titulo="Tipo de Legislação"
        v-if="!carregando && !erro"
      />
    </div>
  </div>
</template>

<script>
import AtoInfralegalApi from "../../services/AtoInfralegalApi";
import Loading from "../../components/Loading";
import ErroResultados from "../../components/ErroResultados";
import PainelBuscaSimplificada from "../../components/PainelBuscaSimplificada";
import { mixinAtoInfralegal } from "../../mixins/mixinAtoInfralegal";

import metaDados from "../../helpers/metaDados";

export default {
  name: "PorTipoAtoInfralegal",
  metaInfo() {
    return {
      title: "Pesquisa de Ato Infralegal por Tipo",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Pesquisa a Legislação por Tipo de Legislação - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Pesquisa a Legislação por Tipo de Legislação - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinAtoInfralegal],
  data() {
    return {
      carregando: true,
      erro: false,
      tipos: [],
      filtro: {
        tipo_ato_infralegal: [],
        ano: null,
      },
    };
  },
  computed: {
    // Parte para formatar os números com separador milhar.
    tiposFormatados() {
      return this.tipos.map((tipo) => {
        return {
          ...tipo,
          quantidade: tipo.quantidade_total,
        };
      });
    },
  },
  components: {
    PainelBuscaSimplificada,
    Loading,
    ErroResultados,
  },
  created() {
    this.atoInfralegalApi = new AtoInfralegalApi();

    this.carregarTipos();
  },
  methods: {
    carregarTipos: async function () {
      try {
        if (this.atoInfralegalApi.cancelTokens.getTipos) {
          this.atoInfralegalApi.cancelTokens.getTipos.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.tipos = await this.atoInfralegalApi.getTipos();
        this.carregando = false;
      } catch (err) {
        if (this.atoInfralegalApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl(ano, dados) {
      this.filtro.tipo_ato_infralegal = dados.id;
      this.filtro.ano = ano;

      this.$router.push({
        name: "PesquisaAtoInfralegal",
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          busca_avancada: 1,
        },
      });
    },
    formatNumber(number) {
      // Método para formatar os números com separador milhar.
      if (number) return number.toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #115810;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}
</style>
